// Unfortunately, :has doesn't work with Firefox yet, so we have to make do with javascript.
// If you're working on this, and :has is now available on all browsers, this can be stripped out and done using CSS instead!

const lastElement = document.querySelector('.element:last-of-type');

if (lastElement && !lastElement.classList.contains('mt-0 mb-0')) {
	lastElement.classList.add('element--last');
}
